module.exports = __webpack_public_path__ + "img/icon-dots.d2338f87.svg";